module.exports = __webpack_public_path__ + "img/doc_1_full.fd77998a.jpg";